/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
  created_on: ['created_on:gte', 'created_on:lte'],
  customer_name: 'customer_name:in',
  expected_departure_on: ['expected_departure_on:gte', 'expected_departure_on:lte'],
  total_weight_min: 'total_weight:gte',
  total_weight_max: 'total_weight:lte',
  total_volume_min: 'total_volume:gte',
  total_volume_max: 'total_volume:lte',
  total_price_min: 'total_price:gte',
  total_price_max: 'total_price:lte',
}

export default parseFilterDataMapping
